import React from "react";
import parseChildren from "../../utils/parseChildren";
import { AssistantPanel, DetailPageContent, } from "../../layouts/DetailPage/DetailPageContent";
import { LoadingScreen } from "../../LoadingScreen";
import { OpacityOverlay } from "../../OpacityOverlay";
import { DetailPageOverview } from "../../layouts/DetailPage/DetailPageOverview";
import { DetailContext } from "../../hooks/useDetailContext";
import { classNames } from "../../utils/classNames";
import { CentreCol, LayoutContainer, LeftCol, Page, RightCol } from "../Layout";
import { Header } from "../..";
export var FutureDetailPage = function (_a) {
    var children = _a.children, title = _a.title, detailType = _a.detailType, legacyId = _a.legacyId, form = _a.form, loading = _a.loading, back = _a.back, header = _a.header, _b = _a.layout, layout = _b === void 0 ? "stacked" : _b, navigation = _a.navigation, page = _a.page;
    var detailChildren = parseChildren(children);
    var content = detailChildren.findByType(DetailPageContent);
    var overview = detailChildren.findByType(DetailPageOverview);
    var assistant = detailChildren.findByType(AssistantPanel);
    if (loading && !legacyId) {
        return React.createElement(LoadingScreen, null);
    }
    return (React.createElement(Page, { className: classNames("detail-page", "detail-".concat(layout)) },
        React.createElement(DetailContext.Provider, { value: {
                title: title,
                legacyId: legacyId,
                detailType: detailType,
                form: form,
                loading: loading,
                layout: layout,
                page: page,
            } },
            React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
                React.createElement(Header, { title: title, extra: header === null || header === void 0 ? void 0 : header.extra, reference: header === null || header === void 0 ? void 0 : header.reference, back: back, navigation: navigation, usage: "portal" }, header === null || header === void 0 ? void 0 : header.children)),
            React.createElement(LayoutContainer, null,
                overview && React.createElement(LeftCol, null, overview),
                React.createElement(CentreCol, null,
                    React.createElement(OpacityOverlay, { on: form.saveState === "saving" }, content)),
                assistant && React.createElement(RightCol, null, assistant)))));
};
